module.exports = __webpack_public_path__ + "img/3DSProjectDemoPoster.8fb2ebc8.png";